module.exports = __webpack_public_path__ + "img/task-8.19876b23.png";